import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { StarMessageListRes } from "../../types/StarMessageListTypes";
import { useAppSelector } from "../../utils/hooks";
import { useLocation } from "react-router-dom";

export const useStarMessageList = () => {
  const CurrentConversation = useAppSelector(
    (state) => state.CurrentConversation,
  );
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updatedFields: any = {};
  let api_name: (string | number)[] = [];

  if (location.pathname !== "/star-messages") {
    updatedFields.chat_id = CurrentConversation.chat_id;
    api_name = ["chat/starred-messages", CurrentConversation.chat_id];
  } else {
    api_name = ["chat/starred-messages"];
  }

  return useQuery<StarMessageListRes, Error>(
    api_name,
    async () => {
      const response = await axiosInstance.post<StarMessageListRes>(
        "chat/starred-messages",
        updatedFields,
      );
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
